<template>
  <div class="block-chain-vote">
    <action-bar>
      <search v-model="inputContent" placeholder="请输入交易哈希" @onSearch="handleSearch"></search>
      <div class="fill"></div>
      <el-select v-model="orgId" class="org-selector" placeholder="选择投票组织" size="medium" @change="handleSelect">
        <el-option
          v-for="item in orgOptions"
          :key="item.OrgId"
          :label="item.OrgName"
          :value="item.OrgId"
        >
        </el-option>
      </el-select>
      <btn-style :btn-list="btnList" class="btn-list-style"></btn-style>
    </action-bar>
    <normal-table
      ref="commonTable"
      :table-col="tableCol"
      :table-data="list"
      :operator="operator"
      :operate-col="operateCol"
      :show-edit="true"
      :paging="paging"
      @pagination="handleSizeOrPageChange"
    >
      <template slot="voteStatus" slot-scope="{ param }">
        <span class="vote-result" :class="param.row.VoteResult | transVoteStatusClass">{{
          param.row.VoteResult | transVoteStatus($constants.EMPTY)
        }}</span>
      </template>
      <template slot="status" slot-scope="{ param }">
        <span class="vote-status" :class="param.row.VoteStatus | transStatusClass">{{
          param.row.VoteStatus | transStatus($constants.EMPTY)
        }}</span>
      </template>
    </normal-table>
    <vote-dialog ref="voteDialog" @update:list="handleRefresh()"></vote-dialog>
    <vote-detail ref="voteDetail"></vote-detail>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import voteDialog from './voteDialog'
import voteDetail from './voteDetail'
import auth from '@/auth/index'
export default {
  name: 'Index',
  components: {
    voteDialog,
    voteDetail
  },
  filters: {
    transStatus: function(value, defaultVal) {
      if (value == 0) {
        return '投票中'
      } else if (value == 1) {
        return '投票完成'
      } else {
        return defaultVal
      }
    },
    transStatusClass: function(value) {
      if (value == 0) {
        return 'is-voting'
      } else if (value == 1) {
        return 'is-success'
      } else {
        return ''
      }
    },
    transVoteStatus: function(value, defaultVal) {
      if (value == 0) {
        return '未投票'
      } else if (value == 1) {
        return '同意'
      } else if (value == 2) {
        return '不同意'
      } else {
        return defaultVal
      }
    },
    transVoteStatusClass: function(value) {
      if (value == 0) {
        return 'is-not-voted'
      } else if (value == 1) {
        return 'is-agree'
      } else if (value == 1) {
        return 'is-disagree'
      } else {
        return ''
      }
    }
  },
  data() {
    return {
      btnList: [
        {
          btnContent: '刷新',
          click: () => {
            return this.handleRefresh()
          },
          type: 'default',
          icon: 'icon-refresh'
        }
      ],
      orgId: '',
      inputContent: '',
      orgOptions: [],
      // 设置table的列
      tableCol: [
        {
          prop: 'CreateTime',
          label: '发起时间',
          formatter: row => {
            return this.formatTime(row.CreateTime * 1000)
          },
          minWidth: 220
        },
        {
          prop: 'StartOrgName',
          label: '发起组织',
          minWidth: 147
        },
        {
          prop: ' VoteType',
          label: '投票事件',
          formatter: row => {
            return this.voteEvent(row.VoteType)
          },
          minWidth: 148
        },
        {
          prop: 'PolicyType',
          label: '投票规则',
          formatter: row => {
            return this.voteRule(row.PolicyType)
          },
          minWidth: 146
        },
        {
          prop: 'PassPercent',
          label: '当前通过率',
          minWidth: 132
        },
        {
          prop: 'VoteResult',
          label: '是否同意',
          formatter: row => {
            return this.agreeStatus(row.VoteResult)
          },
          minWidth: 124,
          slotName: 'voteStatus'
        },
        {
          prop: 'VoteStatus',
          label: '投票状态',
          formatter: row => {
            return this.voteStatus(row.VoteStatus)
          },
          minWidth: 141,
          slotName: 'status'
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '查看',
          click: (row, col, cellValue) => {
            return this.goDetail(row)
          },
          showText: true,
          icon: 'icon-check',
          formatter: row => {
            return this.$utils.hasAuth(this.$store, auth.blockchain.checkDetail.voteManage.check)
          }
        },
        {
          text: '投票',
          click: (row, col, cellValue) => {
            return this.vote(row)
          },
          showText: true,
          icon: 'icon-vote',
          formatter: row => {
            return this.judgeHide(row)
          }
        }
      ],
      operateCol: {
        minWidth: 109
      }
    }
  },
  computed: {
    ...mapState({
      list: state => state.chain.chain_vote_list,
      paging: state => state.chain.chain_vote_paging
    })
  },
  mounted() {
    this.getOrgOption()

    console.log(this.orgOptions)
  },
  methods: {
    ...mapActions(['getVoteLists']),
    getList(limit = 10, offset = 0) {
      let params = {
        OrgCid: this.orgId,
        TxId: this.inputContent,
        offset,
        limit
      }
      this.getVoteLists(params)
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    handleRefresh() {
      const { offset, limit } = this.paging
      this.getList(limit, offset)
    },
    refresh() {
      this.inputContent = ''
      this.getList()
    },
    getOrgOption() {
      let param = {
        offset: 0,
        limit: 50,
        chainId: this.$route.query.chainId
      }
      this.$apis.chain.getChainOrgList(param).then(res => {
        if (res.data.items) {
          this.orgOptions = res.data.items
          this.orgId = this.orgOptions[0]['OrgId']
          this.getList()
        }
      })
    },
    handleSelect(val) {
      this.orgId = val
      this.getList()
    },
    handleSearch(value) {
      this.inputContent = value
      this.getList()
    },
    vote(row) {
      this.$refs.voteDialog.handleOpen(row)
    },
    goDetail(row) {
      this.$refs.voteDetail.handleOpen(row)
    },
    judgeHide(row) {
      return row.VoteStatus === 0 && row.VoteResult === 0
    },
    agreeStatus(status) {
      let arr = ['未投票', '同意', '不同意']
      return arr[status]
    },
    voteStatus(status) {
      let statusArr = ['投票中', '投票完成']
      return statusArr[status]
    },
    voteEvent(event) {
      let eventList = [
        '节点增加更新',
        '根证书更新',
        '共识删除',
        '更新区块配置',
        '部署合约',
        '更新合约',
        '冻结合约',
        '解冻合约',
        '撤销合约'
      ]
      return eventList[event]
    },
    voteRule(rule) {
      let ruleList = ['Majority', 'Any', 'Self', 'All', 'Forbidden', 'All']
      return ruleList[rule]
    },
    formatTime(time) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', time)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'block-chain-vote',
  (
    --block-chain-vote-list-operate-color: #45c2ff,
    --block-chain-vote-list-operate-danger-color: #e95757,
    --block-chain-vote-list-status-voting: #fac20a,
    --block-chain-vote-list-status-success: #55da62,
    --block-chain-vote-list-status-rejected: #45c2ff,
    --block-chain-vote-list-status-failed: #e95757,
    --block-chain-vote-list-status-not-voted: #fac20a,
    --block-chain-vote-list-status-agree: #55da62,
    --block-chain-vote-list-status-disagree: #e95757
  ),
  (
    --block-chain-vote-list-operate-color: #45c2ff,
    --block-chain-vote-list-operate-danger-color: #e95757,
    --block-chain-vote-list-status-voting: #fac20a,
    --block-chain-vote-list-status-success: #55da62,
    --block-chain-vote-list-status-rejected: #45c2ff,
    --block-chain-vote-list-status-failed: #e95757,
    --block-chain-vote-list-status-not-voted: #fac20a,
    --block-chain-vote-list-status-agree: #55da62,
    --block-chain-vote-list-status-disagree: #e95757
  )
);
.block-chain-vote {
  @include adaptation(
    (
      --block-chain-vote-unavaliable-height: 166px
    )
  );
  --block-chain-vote-min-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--block-chain-vote-unavaliable-height)
  );
  .btn-list-style {
    margin-left: var(--base-size-16);
  }

  .org-selector {
    /deep/ {
      .el-input__inner {
        height: var(--base-size-32);
        line-height: var(--base-size-32);
      }

      .el-input__icon {
        line-height: var(--base-size-32);
      }
    }
  }

  .normal-table-wrap {
    height: 100%;
    min-height: var(--block-chain-vote-min-height);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--block-chain-vote-min-height);
      }

      .normal-table {
        height: 100%;
        min-height: var(--block-chain-vote-min-height);

        .vote-result {
          &.is-not-voted {
            color: var(--block-chain-vote-list-status-not-voted);
          }

          &.is-agree {
            color: var(--block-chain-vote-list-status-agree);
          }

          &.is-disagree {
            color: var(--block-chain-vote-list-status-disagree);
          }
        }

        .vote-status {
          &.is-voting {
            color: var(--block-chain-vote-list-status-voting);
          }

          &.is-success {
            color: var(--block-chain-vote-list-status-success);
          }

          &.is-rejected {
            color: var(--block-chain-vote-list-status-rejected);
          }

          &.is-failed {
            color: var(--block-chain-vote-list-status-failed);
          }
        }

        .operate-item {
          color: var(--block-chain-vote-list-operate-color);

          &.operate-danger {
            color: var(--block-chain-vote-list-operate-danger-color);
          }
        }
      }
    }
  }
}
</style>
